import * as client from "../../../client";

// Perils shown as selectable. `included_perils` also allows the legacy
// "wind_and_hail", which we never offer here but preserve if already present.
type Perils = client.PolicyInfo["included_perils"];

// When AOP is selected these perils are forced on (and locked).
export const AOP_LINKED_PERILS: client.peril_type[] = [
  "wildfire",
  "named_storm",
  "scs",
];

/** A peril whose checkbox is disabled because AOP forces it on. */
export const isPerilLocked = (
  perils: Perils,
  peril: client.peril_type
): boolean => perils.includes("aop") && AOP_LINKED_PERILS.includes(peril);

/** Toggle a peril, enforcing EQ↔EM exclusivity and AOP's linked perils. */
export const togglePeril = (
  perils: Perils,
  peril: client.peril_type,
  enabled: boolean
): Perils => {
  let next: Perils = enabled
    ? perils.includes(peril)
      ? perils
      : [...perils, peril]
    : perils.filter((p) => p !== peril);

  // Earthquake and earth movement are mutually exclusive.
  if (next.includes("earthquake") && next.includes("earth_movement")) {
    if (peril === "earthquake") {
      next = next.filter((p) => p !== "earth_movement");
    }
    if (peril === "earth_movement") {
      next = next.filter((p) => p !== "earthquake");
    }
  }

  // Selecting AOP forces its linked perils on.
  if (next.includes("aop")) {
    for (const linked of AOP_LINKED_PERILS) {
      if (!next.includes(linked)) next = [...next, linked];
    }
  }

  return next;
};
